import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { practiceDataAtom } from '../state/practice';

export type PendoMetadata = {
	account: {
		id: string;
		name: string;
	};
};

export function usePendoMetadata(): PendoMetadata | null {
	const practiceData = useAtomValue(practiceDataAtom);

	return useMemo(() => {
		if (
			!practiceData ||
			!practiceData.practiceName ||
			!practiceData.clientIdentity
		) {
			return null;
		}

		return {
			visitor: {
				id: `flexadmin-${practiceData.clientIdentity}`,
			},
			account: {
				id: practiceData.clientIdentity,
				name: practiceData.practiceName,
			},
		};
	}, [practiceData]);
}
